import { useSelector } from 'react-redux';
import { getPurchaseComputed } from '../../selector';
import { IStore } from 'store/interface';
import { IPurchasesRecord } from '../../interfaces';

export const usePurchaseComputed = () => ({
  computed: useSelector<IStore, IPurchasesRecord['computed']>(getPurchaseComputed),
});
